var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusOncolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.986L12.9976 12.986H11.0036L6.0041 13C5.87209 13.0005 5.74128 12.9752 5.61921 12.9255C5.49714 12.8758 5.38624 12.8027 5.29289 12.7103C5.19955 12.618 5.12561 12.5083 5.07534 12.3876C5.02507 12.2669 4.99947 12.1375 5.00001 12.007C4.99947 11.8764 5.02507 11.7471 5.07534 11.6264C5.12561 11.5056 5.19955 11.396 5.29289 11.3036C5.38624 11.2113 5.49714 11.1382 5.61921 11.0885C5.74128 11.0388 5.87209 11.0135 6.0041 11.014L11.0036 11.014L12.9976 11.014L18 11C18.2663 11 18.5217 11.1046 18.71 11.2908C18.8983 11.4771 19.0041 11.7296 19.0041 11.993C19.0041 12.2564 18.8983 12.5089 18.71 12.6952C18.5217 12.8814 18.2663 12.986 18 12.986Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusOncolor);
export default __webpack_public_path__ + "static/media/minus_oncolor.cb5ab797a51adf55fdd1e1fad2c64bb2.svg";
export { ForwardRef as ReactComponent };